 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBADFRONT from '@/components/ebadfront'
 import TLU from '@/components/tlu'
 import AD1 from '@/components/ad1'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/title'
 import DED from '@/components/ded'
 import TOC from '@/components/toc'
 import FWD from '@/components/fwd'
 import FM1 from '@/components/fm1'
 import CHAP01 from '@/components/chap01'
 import LONDON from '@/components/london'
 import CHAP02 from '@/components/chap02'
 import CHAP03 from '@/components/chap03'
 import CHAP04 from '@/components/chap04'
 import CHAP05 from '@/components/chap05'
 import CHAP06 from '@/components/chap06'
 import CHAP07 from '@/components/chap07'
 import CHAP08 from '@/components/chap08'
 import CHAP09 from '@/components/chap09'
 import CHAP10 from '@/components/chap10'
 import CHAP11 from '@/components/chap11'
 import CHAP12 from '@/components/chap12'
 import CHAP13 from '@/components/chap13'
 import CHAP14 from '@/components/chap14'
 import CHAP15 from '@/components/chap15'
 import CHAP16 from '@/components/chap16'
 import JERSY from '@/components/jersy'
 import CHAP17 from '@/components/chap17'
 import LOVE_2 from '@/components/love_2'
 import BIO from '@/components/bio'
 import COPY from '@/components/copy'
 import AUBA from '@/components/auba'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/fwd",
 			"name" : "fwd",
 			"component" : FWD
 		},
 		{
 			"path" : "/fm1",
 			"name" : "fm1",
 			"component" : FM1
 		},
 		{
 			"path" : "/chap01",
 			"name" : "chap01",
 			"component" : CHAP01
 		},
 		{
 			"path" : "/london",
 			"name" : "london",
 			"component" : LONDON
 		},
 		{
 			"path" : "/chap02",
 			"name" : "chap02",
 			"component" : CHAP02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js